import React, { Component } from 'react';
import { connect } from 'react-redux';
import { IN_PROGRESS as FETCHING_STATUS_IN_PROGRESS } from 'constants/status/fetchingStatus';
import TravelSummaryComponent from './TravelSummaryComponent';

const defaultConfig = {
  content: {},
  button: {},
  summaries: {},
  promotions: {},
};

class TravelSummary extends Component {
  render() {
    const { packagesSearch, headerHeight, config, onClickClose, isHotelPage, disclaimer, refInView } = this.props;
    const { fetching, value } = packagesSearch;

    if (fetching === null && value === null) {
      return null;
    }

    const fetchingFinished = fetching !== null && fetching !== FETCHING_STATUS_IN_PROGRESS;
    const noResults = value === null || (value !== null && value.packages === undefined);
    const packagePriceChanged = value && value.packages[0].packagePriceChanged;

    if (fetchingFinished && noResults) {
      return null;
    }

    const _config = {
      ...defaultConfig,
      ...config,
    };

    return (
      <TravelSummaryComponent
        headerHeight={headerHeight}
        config={_config}
        onClickClose={onClickClose}
        isHotelPage={isHotelPage}
        packagePriceChanged={packagePriceChanged}
        disclaimer={disclaimer}
        refInView={refInView}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    packagesSearch: state.checkoutPagePackagesSearch,
    headerHeight: state.refs.headerHeight,
    isHotelPage: state.currentPageComponent.isHotelPage,
    disclaimer: state.settings.value.customSettings && state.settings.value.customSettings.disclaimer,
  };
}

export default connect(mapStateToProps)(TravelSummary);
